import { Cpu } from 'lucide-react';
import { cn } from '@/lib/utils';
import { CONTROLLER_CONFIG } from '@/lib/controllerConfig';
import { IControllerType } from '@/redux/post/post.d';

/** The controller's brand mark, from the shared config the model-details page
 * already uses. Falls back to the name as text for controllers without a logo
 * (Buildbotics reuses the Onefinity mark). Inline rather than an icon library
 * so every "which machine" in the wizard carries the same visual cue. */
export default function ControllerLogo({
  name,
  className = 'w-[18px] h-[18px]',
}: {
  name: string;
  className?: string;
}) {
  const config =
    CONTROLLER_CONFIG[name as IControllerType] ??
    Object.values(CONTROLLER_CONFIG).find((c) => c.name === name);

  if (config?.icon) {
    const Icon = config.icon;
    return <Icon className={className} />;
  }

  return <Cpu className={cn(className, 'text-muted-foreground')} />;
}
